<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="请选择项目"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6" >
            <el-form-item>
              <el-button type="primary" size="medium" @click="onSubmit" >搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" />
    </basic-container>
  </div>
</template>

<script>
import urlSettings from '@/config/url-settings';
import WebReport from '@/components/web-report';
import {getProjectList} from "@/api/crmedical/report/examine.js";
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      url: '',
      form: {
        projectId: [],
      },
      allPropertyList: [],
      oldOptions: [],
      params: {
        reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/contractPayment.cpt',
        //  reportlet: 'oweSummary.cpt',
      },
      dic: [],
    };
  },
  methods: {


    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.projectId = `${this.form.projectId}`;

          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    initPropertyList() {
      // periodList
      var that = this;

      getProjectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
        }
        if (this.$route.query.id) {
          setTimeout(() => {
            this.onLoad_();
          });
        } else {
          setTimeout(() => {
            this.onLoad();
          });
        }
        var reportUrl = urlSettings.BASE_REPORT_URL;

        this.url = reportUrl.split('?')[0];
        //this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=examine.cpt';

        this.params.projectId =  this.form.projectId;

        setTimeout(() => {
          this.$refs.WebReport.regroupUrl();
        }, 0);
      });
    },
  },

  created() {

    this.initPropertyList ();

  },
};
</script>

<style></style>
